<template>
  <div class="box">
    <div class="box-header with-border">
      <h3 class="box-title">Anchors</h3>
    </div>
    <!-- /.box-header -->
    <div class="box-body anchor" v-bind:class="{ 'no-padding': anchors && anchors.length > 0 }">

      <div class="anchor-button">
        <button type="button" class="btn btn-primary btn-lg btn-block" v-on:click="confirmAnchor">
          <i class="ion ion-android-lock lock-icon"></i> Anchor now
        </button>
      </div>

      <p class="anchor-label" v-if="anchors.length == 0">This item has not been anchored yet</p>

      <div v-if="anchors.length > 0" class="row">
        <div class="col-sm-12 table-responsive">

          <table role="grid" class="table table-bordered table-striped no-margin">
            <thead>
              <tr role="row">
                <th aria-label="Achor Date" colspan="1" rowspan="1" tabindex="0">Anchor Date</th>
                <th aria-label="User" colspan="1" rowspan="1" tabindex="0">User</th>
                <th aria-label="file" colspan="1" rowspan="1" tabindex="0">File</th>
              </tr>
            </thead>
            <tbody>
              <tr class="even" role="row" v-for="anchor in anchors">
                <td>{{anchor.timestamp | prettyDateTime}}</td>
                <td>{{anchor.anchoredBy.firstName}} {{anchor.anchoredBy.lastName}}</td>
                <td>
                  <a class="file-name" v-bind:href="getUrl(anchor)">
                    <i data-toggle="tooltip" data-placement="bottom" title="Download" class="fa fa-file clickable"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    <!-- Prepare button to display/hide table on click -->
      <!-- <div class="box-footer">
        <div>See <i class="ion ion-eye"></i></div>
      </div> -->

      <!-- /.box-body -->
    </div>
    <confirm-modal message="Do you really want to secure and anchor this item ?" title="Secure Confirmation" @confirm="anchor()" id="ConfirmAnchorModal"></confirm-modal>
  </div>
</template>

<script>
import api from '../../api'
import config from '../../config'

export default {
  name: 'Anchors',
  props: ['type', 'id', 'version'],
  data () {
    return {
      anchors: []
    }
  },
  methods: {
    getUrl (anchor) {
      let endpoint
      if (this.type === 'cases') {
        endpoint = `/cases/${this.id}/anchor/${
          anchor._id
        }?token=${window.localStorage.getItem('token').substring(7)}`
      } else {
        endpoint = `/testimonies/${this.id}/anchor/${
          anchor.version
        }?token=${window.localStorage.getItem('token').substring(7)}`
      }
      return `${config.serverURI}${endpoint}`
    },
    download (anchorId) {
      console.log(
        'try to download the ZIP file corresponding to the anchor : ' + anchorId
      )
    },
    confirmAnchor () {
      window.jQuery('#ConfirmAnchorModal').modal({})
    },
    anchor () {
      let endpoint
      if (this.type === 'cases') {
        endpoint = `/cases/${this.id}/anchor`
      } else {
        endpoint = `/testimonies/${this.id}/anchor/${this.version}`
      }

      api
        .authenticatedRequest('post', endpoint)
        .then(response => {
          this.getAnchors()
          if (this.type === 'testimonies') {
            this.$emit('anchorDone', { response: response.data.testimony })
          }
        })
        .catch(error => {
          console.log(error)
          this.goToReadMode()
          if (error.response.status === 401) {
            // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    },
    getAnchors () {
      api
        .authenticatedRequest('get', `/${this.type}/${this.id}/anchor`)
        .then(response => {
          this.anchors = response.data.data
        })
        .catch(error => {
          console.log(error)
          if (error.response.status === 401) {
            // InvalidCredentialsError
            this.response = 'Username/Password incorrect. Please try again.'
            return
          }
          this.response = 'Server appears to be offline'
        })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getAnchors()
    })
  }
}
</script>

<style>
.anchor-label {
  text-align: center;
  margin-top: 10px;
}

.lock-icon {
  margin-right: 5px;
  font-size: 20px;
}

.anchor-button {
  padding: 10px;
}

.box-body.anchor {
  padding: 0;
  padding-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// Anchors.vue?00ad9f0d